import { render, staticRenderFns } from "./RouteBtnTip.vue?vue&type=template&id=631be8ae&scoped=true&"
import script from "./RouteBtnTip.vue?vue&type=script&lang=js&"
export * from "./RouteBtnTip.vue?vue&type=script&lang=js&"
import style0 from "./RouteBtnTip.vue?vue&type=style&index=0&id=631be8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631be8ae",
  null
  
)

export default component.exports